module.exports = __webpack_public_path__ + "img/erweima.89cf5ff2.png";